module.exports = __webpack_public_path__ + "assets/img/bottom_logo.9d351ed0.png";